import GUI from 'lil-gui'

/**
 * Debug
 * Wraps lil-gui and activates only when the URL hash contains '#debug'.
 * Usage: window.location.hash === '#debug'  →  this.experience.debug.active === true
 * Access the GUI panel: this.experience.debug.ui
 *
 * Pattern in child classes:
 *   if (this.experience.debug.active) {
 *       const folder = this.experience.debug.ui.addFolder('My Object')
 *       folder.add(this.mesh.position, 'y').min(-3).max(3).step(0.01)
 *   }
 */
export default class Debug {
    constructor() {
        this.active = window.location.hash === '#debug'

        if (this.active) {
            this.ui = new GUI({ width: 340 })
        }
    }
}
